<script setup lang="ts">
import { computed } from 'vue'

import { usePipe } from '../../../composables/usePipe'
import { getColorStyleData, getSpacingStyleData } from '../../../composables/useStyleData'

import TipTap from '@render/lib/TipTap'
import type { TranslationKeyField } from '@/api'
import type { HeadingFields as Model } from './definition'

const fields = defineModel<Model>('fields', {
  required: true,
  default: () => ({
    body: { type: 'translation_key', key: '' } satisfies TranslationKeyField,
  }),
})
const pipe = usePipe()

const value = computed({
  get: () => {
    return pipe.getTranslation(fields.value.body?.key)
  },
  set: (newVal: object) => {
    // Every FieldValues<> key is optional (a stored pipe may omit any field).
    const key = fields.value.body?.key
    if (key) pipe.setTranslation(key, newVal)
  },
})
const devHeadingColor = computed(() =>
  getColorStyleData(fields.value.color, 'var(--color-secondary)'),
)
const devHeadingPadding = computed(() => getSpacingStyleData(fields.value.padding, 'inherit'))
const devHeadingMargin = computed(() => getSpacingStyleData(fields.value.margin, 'inherit'))
const devHeadingTextAlign = computed(() => fields.value.textAlign)
</script>

<template>
  <component :is="'h' + fields.heading" class="dev-heading">
    <div v-if="!fields.body">No translation key set!</div>
    <TipTap v-else v-model="value" mode="single" />
  </component>
</template>

<style scoped>
.dev-heading {
  color: v-bind(devHeadingColor);
  padding: v-bind(devHeadingPadding);
  margin: v-bind(devHeadingMargin);
  text-align: v-bind(devHeadingTextAlign);
  word-wrap: break-word;
}
</style>
